import { ServiceApi } from "utils/utilAmplify";
import {
  IEmail,
  IPerson,
  IResponseShort,
  ISearchPreferences
} from "interfaces/intarfaces";
import { TUserShort } from "../interfaces/interfacesChat";
import { ServiceName } from "../config/amplify";

class UserAPIClass {
  private readonly api: ServiceApi;

  constructor() {
    this.api = new ServiceApi(ServiceName.UsersProfile);
  }
  getShortDescription(
    ids: string[]
  ): Promise<{ users_short_description: TUserShort[] }> {
    const userIdsQuery = ids.map((id) => `user_ids=${id}`).join("&");
    return this.api.get("short-description/?" + userIdsQuery);
  }
  getUser(id: string, options?: { [key: string]: any }): Promise<IPerson> {
    return this.api.get(id, options);
  }
  getUserPreview(id: string): Promise<Partial<IPerson>> {
    return this.api.get(`${id}/user-preview`);
  }
  createHost(body: Partial<IPerson>): Promise<IPerson> {
    return this.api.post("host/", body);
  }
  createStudent(body: Partial<IPerson>): Promise<IPerson> {
    return this.api.post("student/", body);
  }
  updateHost(userId: string, body: Partial<IPerson>): Promise<IPerson> {
    return this.api.patch(`host/${userId}`, body);
  }
  updateStudent(userId: string, body: Partial<IPerson>): Promise<IPerson> {
    return this.api.patch(`student/${userId}`, body);
  }
  delete(userId: string): Promise<IResponseShort> {
    return this.api.del(userId);
  }
  uploadAvatar(
    userId: string,
    image: File,
    { showNotificationOnError = true }
  ): Promise<IResponseShort> {
    const formData = new FormData();
    formData.append("user_image", image);

    return this.api.post(`${userId}/upload-avatar`, formData, {
      Accept: "image/jpeg",
      showNotificationOnError
    });
  }
  contactUs(contactEmail: string, body: IEmail): Promise<IResponseShort> {
    return this.api.post(`contact-us/${contactEmail}`, body);
  }
  setSearchPreferences(payload: ISearchPreferences) {
    return this.api.post("student/set-search-preferences", payload);
  }
  requestVerification(userId: string) {
    return this.api.post(`${userId}/request-verification`);
  }
}

export const UserAPI = new UserAPIClass();
